import { Link } from 'react-router-dom'

function NavBar() {
  return (
    <header className="fixed top-0 inset-x-0 z-50 border-b border-cosmic-mist/50 bg-cosmic-void/80 backdrop-blur-md">
      <div className="max-w-4xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 group">
          <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-violet-deep to-violet-mid flex items-center justify-center shadow-glow-violet">
            <span className="text-gold text-sm">✦</span>
          </div>
          <span className="font-display text-xl font-light text-star-white tracking-wide group-hover:text-gold transition-colors">
            Shubh Time
          </span>
        </Link>
        <Link to="/login" className="text-sm text-star-soft hover:text-star-bright transition-colors">
          Sign in
        </Link>
      </div>
    </header>
  )
}

export function TermsPage() {
  return (
    <div className="min-h-screen bg-cosmic-void text-star-white">
      <NavBar />
      <main className="pt-24 pb-20 px-6 max-w-4xl mx-auto">
        <h1 className="font-display text-3xl font-light text-star-white mb-2">Terms of Service</h1>
        <p className="text-star-dim text-sm font-mono mb-10">Last updated: May 2026</p>

        <div className="prose prose-invert prose-sm max-w-none space-y-8 text-star-soft leading-relaxed">

          <section>
            <h2 className="text-star-white text-lg font-semibold mb-3">1. Acceptance of Terms</h2>
            <p>
              By accessing or using Shubh Time ("Service"), you agree to be bound by these Terms of Service
              ("Terms"). If you do not agree to these Terms, do not use the Service.
            </p>
          </section>

          <section>
            <h2 className="text-star-white text-lg font-semibold mb-3">2. Description of Service</h2>
            <p>
              Shubh Time provides Vedic astrology tools including birth chart analysis, muhurta timing,
              dasha period interpretation, and related features. The Service is provided for informational
              and entertainment purposes only.
            </p>
          </section>

          <section>
            <h2 className="text-star-white text-lg font-semibold mb-3">3. No Professional Advice</h2>
            <p>
              Shubh Time is not a substitute for professional advice. Astrological interpretations
              provided through the Service are for informational purposes only and should not be relied
              upon for medical, financial, legal, or other professional decisions.
            </p>
          </section>

          <section>
            <h2 className="text-star-white text-lg font-semibold mb-3">4. Account Registration</h2>
            <p>
              You must create an account to access certain features. You are responsible for maintaining
              the confidentiality of your account credentials and for all activity that occurs under your
              account. You must provide accurate information during registration.
            </p>
          </section>

          <section>
            <h2 className="text-star-white text-lg font-semibold mb-3">5. Subscription and Billing</h2>
            <p>
              Premium features require a paid subscription. Subscriptions renew automatically unless
              cancelled. You may cancel your subscription at any time through your account settings.
              Refunds are issued at our discretion in accordance with applicable law.
            </p>
          </section>

          <section>
            <h2 className="text-star-white text-lg font-semibold mb-3">6. Acceptable Use</h2>
            <p>You agree not to:</p>
            <ul className="list-disc list-inside space-y-1 mt-2 text-star-dim">
              <li>Use the Service for any unlawful purpose</li>
              <li>Attempt to gain unauthorized access to any part of the Service</li>
              <li>Reverse engineer, decompile, or disassemble the Service</li>
              <li>Use automated means to access the Service without our permission</li>
              <li>Transmit harmful, offensive, or disruptive content</li>
            </ul>
          </section>

          <section>
            <h2 className="text-star-white text-lg font-semibold mb-3">7. Intellectual Property</h2>
            <p>
              All content, features, and functionality of the Service are owned by Shubh Time and
              protected by applicable intellectual property laws. You may not reproduce, distribute,
              or create derivative works without our written permission.
            </p>
          </section>

          <section>
            <h2 className="text-star-white text-lg font-semibold mb-3">8. Limitation of Liability</h2>
            <p>
              To the maximum extent permitted by law, Shubh Time shall not be liable for any indirect,
              incidental, special, consequential, or punitive damages arising from your use of the Service.
              Our total liability shall not exceed the amount you paid for the Service in the 12 months
              preceding the claim.
            </p>
          </section>

          <section>
            <h2 className="text-star-white text-lg font-semibold mb-3">9. Termination</h2>
            <p>
              We reserve the right to suspend or terminate your account at any time for violation of
              these Terms or for any other reason at our sole discretion, with or without notice.
            </p>
          </section>

          <section>
            <h2 className="text-star-white text-lg font-semibold mb-3">10. Changes to Terms</h2>
            <p>
              We may update these Terms from time to time. We will notify you of material changes
              via email or through the Service. Continued use of the Service after changes constitutes
              acceptance of the updated Terms.
            </p>
          </section>

          <section>
            <h2 className="text-star-white text-lg font-semibold mb-3">11. Contact</h2>
            <p>
              For questions about these Terms, contact us at{' '}
              <a href="mailto:support@shubhtime.in" className="text-gold hover:text-gold/80 transition-colors">
                support@shubhtime.in
              </a>
              .
            </p>
          </section>

        </div>

        <div className="mt-12 pt-8 border-t border-cosmic-mist/30 flex gap-6 text-sm">
          <Link to="/privacy" className="text-gold/70 hover:text-gold transition-colors">Privacy Policy</Link>
          <Link to="/" className="text-star-dim hover:text-star-soft transition-colors">← Back to home</Link>
        </div>
      </main>
    </div>
  )
}
